import React from 'react'

import FacebookPostSkeleton from './FacebookPostSkeleton'

function FacebookPostsListSkeleton() {
  return (
    <>
      <FacebookPostSkeleton />
      <FacebookPostSkeleton />
      <FacebookPostSkeleton />
      <FacebookPostSkeleton />
      <FacebookPostSkeleton />
    </>
  )
}

export default FacebookPostsListSkeleton
